export class EnvValidationError extends Error {
    errors;
    constructor(errors) {
        const message = `Environment validation failed:\n${errors.map((error) => `  - ${error}`).join('\n')}`;
        super(message);
        this.name = 'EnvValidationError';
        this.errors = errors;
    }
}
